import { PropsCell } from '../common/Table/TableHeader';

export const headCellsLoans: PropsCell[] = [
  { id: 'id', numeric: false, disablePadding: false, label: 'ID' },
  {
    id: 'users_str',
    numeric: false,
    disablePadding: false,
    label: 'Usuario (ID)',
  },
  {
    id: 'created',
    numeric: false,
    disablePadding: false,
    label: 'Fechas de prestamo',
  },
  {
    id: 'loan_status_str',
    numeric: false,
    disablePadding: false,
    label: 'Estatus',
    center: true,
  },
  { id: 'details', numeric: false, disablePadding: false, label: 'Detalle' },
];

export const fieldsFilter = [
  { key: 'nid', name: 'NID de Propiedad' },
  { key: 'barcode', name: 'Código de barras de una llave' },
];

export const fieldsFilterUser = [
  { key: 'id', name: 'Id de usuario' },
  { key: 'barcode', name: 'Código de barras de usuario' },
];

export const fieldsFilterList = [
  { key: 'id', name: 'Id de prestamo' },
  { key: 'users_id', name: 'Id de usuario' },
  { key: 'loan_status_id', name: 'Estatus' },
  { key: 'properties_nid', name: 'NID' },
  { key: 'created', name: 'Fecha de prestamo'},
];

export const listDays = [
  {
    value: 2,
    label: '2 días',
  },
  {
    value: 4,
    label: '4 días',
  },
  {
    value: 6,
    label: '6 días',
  },
];

export const valuesEstatus = [
  { key: '1', name: 'Activo' },
  { key: '2', name: 'Concluido / devuelto' },
  { key: '3', name: 'Eliminado' },
];
